import { useCallback, useEffect, useState } from 'react';

function isFullscreenSupported() {
  return typeof document !== 'undefined' &&
    'fullscreenEnabled' in document &&
    document.fullscreenEnabled &&
    typeof document.documentElement.requestFullscreen === 'function';
}

export function useFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(() =>
    typeof document !== 'undefined' ? !!document.fullscreenElement : false,
  );
  const [isSupported] = useState(() => isFullscreenSupported());

  useEffect(() => {
    if (!isSupported) return;

    const handleChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', handleChange);
    return () => document.removeEventListener('fullscreenchange', handleChange);
  }, [isSupported]);

  const toggle = useCallback(async () => {
    if (!isSupported) return;

    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch {
      // 部分浏览器（如嵌入式 WebView）会拒绝全屏请求，静默失败即可
    }
  }, [isSupported]);

  return { isFullscreen, isSupported, toggle };
}
